import * as types from '../actions/actionTypes';

const initialState = {
    page: 1,
    resultsView: 12,
    sort: {
        by: '',
        direction: ''
    },
    loading: false,
    success: true,
    data: {
        totalCount: 0,
        records: []
    },
    currentRequestId: 0,
    selected: [],
    updating: {},
    removing: {
        loading: false,
        success: true,
        message: ''
    }
};

export default tableType => {
    return (state = initialState, action) => {
        switch (action.type) {
            case types[`UPDATE_${tableType}_TABLE`]:
                return Object.assign({}, state, action.settings);

            case types[`CLEAR_${tableType}_TABLE_RECORDS`]:
                return Object.assign({}, state, { data: initialState.data });
            case types[`START_GET_${tableType}_TABLE_RECORDS`]:
                return Object.assign({}, state, { loading: true, success: true, currentRequestId: action.requestId });
            case types[`GET_${tableType}_TABLE_RECORDS`]:
                return action.requestId !== state.currentRequestId ? state
                    : Object.assign({}, state, {
                        ...action.response,
                        data: { ...initialState.data, ...action.response.data },
                        ...Object.keys(state.updating).length ? {
                            updating: Object.keys(state.updating)
                                .filter(key => state.updating[key])
                                .reduce((obj, key) => {
                                    obj[key] = state.updating[key];
                                    return obj;
                                }, {})
                        } : {}
                    });

            case types[`START_UPDATE_${tableType}_TABLE_RECORD`]:
                return Object.assign({}, state, {
                    updating: { ...state.updating, ...{ [action.recordId]: true } }
                });
            case types[`UPDATE_${tableType}_TABLE_RECORD`]:
                let updatingRecords = { ...state.updating };
                action.response.success
                    ? delete updatingRecords[action.response.recordId]
                    : updatingRecords[action.response.recordId] = action.response.message || false;

                let records = [...state.data.records];
                if (action.response.success) {
                    var index = records.map(rec => rec[action.response.recordIdKey]).indexOf(action.response.recordId);
                    if (index >= 0) { records[index] = { ...records[index], ...action.response.update }; }
                }

                return Object.assign({}, state, {
                    data: { ...state.data, records },
                    updating: updatingRecords
                });

            case types[`TOGGLE_SELECT_${tableType}_TABLE_RECORD`]:
                const selectedRecordId = action.record[action.recordIdKey];
                const selected = state.selected.map(rec => rec[action.recordIdKey]).indexOf(selectedRecordId) < 0
                    ? [...state.selected, action.record] : state.selected.filter(rec => rec[action.recordIdKey] !== selectedRecordId);
                return Object.assign({}, state, { selected });
            case types[`CLEAR_${tableType}_TABLE_SELECTION`]:
                return Object.assign({}, state, { selected: [] });

            case types[`START_REMOVE_${tableType}_TABLE_RECORD`]:
                return Object.assign({}, state, { removing: { ...initialState.removing, loading: true } });
            case types[`REMOVE_${tableType}_TABLE_RECORD`]:
                const data = action.response.success
                    ? { totalCount: --state.data.totalCount, records: state.data.records.filter(rec => rec[action.response.recordIdKey] !== action.response.recordId) }
                    : state.data;
                const remainingSelection = state.selected.filter(rec => rec[action.response.recordIdKey] !== action.response.recordId);
                return Object.assign({}, state, {
                    data,
                    selected: remainingSelection,
                    removing: { success: action.response.success, message: action.response.message, loading: false }
                });

            default:
                return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/TableReducer.js